<template>
  <v-alert v-if="paymentAddErrorMessage" type="error" color="error" border="top">
    <v-row align="center">
      <v-col class="grow">
        {{ paymentAddErrorMessage }}
      </v-col>
      <v-col class="shrink">
        <v-btn-var to="/billing/payment-methods/new">
          {{ t("billing.settings.tryAgainButton") }}
        </v-btn-var>
      </v-col>
    </v-row>
  </v-alert>
  <v-alert
    v-else-if="paymentAddSuccessMessage"
    outlined
    dismissible
    type="success"
    color="green"
    class="bg-background black--text"
  >
    {{ paymentAddSuccessMessage }}
  </v-alert>

  <div class="d-flex flex-row flex-wrap justify-space-between">
    <p class="mb-5 me-5" style="max-width: 740px">
      {{ t("billing.settings.description", { email: "help@yetipay.me" }) }}
    </p>
    <div>
      <v-btn to="/billing/payment-methods/new" prepend-icon="mdi-plus">
        {{ t("billing.settings.addNewButton") }}
      </v-btn>
    </div>
  </div>

  <BillingMethodList />
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const paymentAddSuccessMessage = ref("");
const paymentAddErrorMessage = ref("");

const setupPaymentMethodRedirect = () => {
  const { redirect_status } = route.query;

  if (redirect_status === "succeeded") {
    paymentAddSuccessMessage.value = t("billing.settings.successMessage");
  } else {
    console.error("Payment add redirect error");
    paymentAddErrorMessage.value = t("billing.settings.errorMessage");
  }
  router.replace({ query: undefined });
};

onMounted(() => {
  const isRedirect = route.query.redirect;
  if (isRedirect) {
    setupPaymentMethodRedirect();
  }
});
</script>
